<template>
  <div>
    <div :class="['b-tabs__bar', stateClass, { 'b-tabs__bar--secondary': secondary }]">
      <v-tabs class="b-tabs__bar__tabs" v-model="currentTab">
        <v-tab
          :class="{ 'b-tabs__tab--error': tab.state === 'error', 'b-tabs__tab--warning': tab.state === 'warning', 'b-tabs__tab--success' : tab.state === 'success'}"
          v-for="(tab, index) in tabs"
          :key="index"
          :disabled="tab.disabled"
        >{{ tab.text || tab }}</v-tab>
      </v-tabs>
      <div
        v-if="$slots.append"
        class="b-tabs__bar__append"
        :class="{ 'b-tabs__bar__append--separated': separateAppend  }"
      >
        <slot name="append" />
      </div>
    </div>
    <div :class="['b-tabs__content', { 'b-tabs__content--table': table }]">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: Array,
    value: null,
    separateAppend: Boolean,
    secondary: Boolean,
    table: Boolean
  },
  data() {
    return {
      currentTab: this.value
    };
  },
  methods: {
    emitTabValue() {
      const tabValue = this.tabs[this.currentTab]?.value;
      this.$emit('input', tabValue != undefined ? tabValue : this.currentTab);
    }
  },
  watch: {
    value(val) {
      const index = this.tabs.findIndex(tab => tab.value === val);
      this.currentTab = index == undefined ? val : index;
    },
    currentTab() {
      this.emitTabValue();
    },
    tabs() {
      this.emitTabValue();
    }
  },
  computed: {
    stateClass() {
      const state = this.tabs[this.currentTab]?.state;
      return (
        (['error', 'success', 'warning'].includes(state) &&
          `b-tabs__bar--${state}`) ||
        ''
      );
    }
  }
};
</script>

<style lang="scss" scoped>
//public
$slider-line__color: #cfd2d9;
$slider-line__thickness--inactive: 2px;
$slider-line__thickness--active: 4px;
$tab__opacity--hover-or-focus: 0.12;
$tab__color--hover-or-focus: #4137ff;
$tab__text-color--inactive: var(--v-secondary-base);
$content__y-offset: 32px;

//private
$_slider-line: inset 0 (-$slider-line__thickness--inactive) $slider-line__color;

.w-tabs {
  &__tab {
    &--error {
      color: var(--v-error-base) !important;
    }
    &--warning {
      color: var(--v-warning-base) !important;
    }
    &--success {
      color: var(--v-success-base) !important;
    }
  }

  &__bar {
    display: flex;
    box-shadow: $_slider-line;

    &__tabs {
      min-width: 0px;
    }

    &__append {
      flex: none;
      padding-left: 16px;
      display: flex;
      align-items: center;

      &--separated {
        box-shadow: inset 0 (-$slider-line__thickness--inactive) white;
      }
    }
  }

  &__content:not(.b-tabs__content--table) {
    padding-top: $content__y-offset;
  }
}

.v-tab {
  text-transform: none;
  font-weight: 500;
  letter-spacing: normal;
  min-width: 90px;

  &:before {
    background-color: $tab__color--hover-or-focus;
  }
}

.theme--light .v-tabs {
  > .v-tabs-bar .v-tab:not(.v-tab--active) {
    color: $tab__text-color--inactive;
  }

  .v-tab:hover:before {
    opacity: $tab__opacity--hover-or-focus;
  }
}

::v-deep .v-item-group {
  box-shadow: $_slider-line;
}

::v-deep .v-tabs-slider-wrapper {
  height: $slider-line__thickness--active !important;
}

::v-deep .b-tabs__bar--error .v-tabs-slider-wrapper {
  color: var(--v-error-base);
}

::v-deep .b-tabs__bar--warning .v-tabs-slider-wrapper {
  color: var(--v-warning-base);
}

::v-deep .b-tabs__bar--success .v-tabs-slider-wrapper {
  color: var(--v-success-base);
}

::v-deep .b-tabs__bar--secondary > .b-tabs__bar__tabs > .v-tabs-bar {
  height: 44px;
}

::v-deep
  .b-tabs__content--table
  .b-data-table.b-data-table--hide-header
  tbody
  > tr:first-child
  > td {
  border-top: none !important;
}
</style>